import { PageLayoutContentMainAreaAriaRole } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import React, { FC, useMemo } from 'react';

import AppContext, { AppContextOptions, defaultOptions } from './context';

export interface AppContextProviderProps {
  readonly mainAreaAriaRole: PageLayoutContentMainAreaAriaRole;
  readonly options?: Partial<AppContextOptions>;
}

const AppContextProvider: FC<AppContextProviderProps> = ({ mainAreaAriaRole, options, children }) => {
  const contextProps = useMemo(
    () => ({ ...defaultOptions, ...options, mainAreaAriaRole }),
    [options, mainAreaAriaRole]
  );

  return <AppContext.Provider value={contextProps}>{children}</AppContext.Provider>;
};

export default AppContextProvider;
